import { Injectable } from "@angular/core";
import {
  AcepSSOService,
  GlobalDomOpsService,
  GlobalDataOpsService,
  CommonOperationsService
} from "@acepteam/globalspack";
import { MemberAppDomService, MemberAppDataService } from "../../services";
import {
  DomService,
  DataService,
  HelperService,
  LoggerService
} from "../../../core/services";
import { MyAccountDataOpsService } from "../../services/my-account-dataops.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import {
  ChapterDetails,
  ChapterInfo
} from "../../../shared/models/chapter-details";
import { ProductSubType } from "../../../shared/enums/xrm.constants";
import { OrderGenProduct } from "../../../shared/models";
import { CustomerAddress } from "../../../shared/models/my-account-data.models";
import { getPrimaryAddress, MapChapterDetails } from "../../helpers/mapper";
import { tap } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ChaptersService {
  constructor(
    private ssoService: AcepSSOService,
    private globalDomOpsService: GlobalDomOpsService,
    private memberAppDataService: MemberAppDataService,
    private memberAppDomService: MemberAppDomService,
    private domService: DomService,
    private globalDataOpsService: GlobalDataOpsService,
    private dataService: DataService,
    private myAccountDataService: MyAccountDataOpsService,
    private commonOpsService: CommonOperationsService,
    private helperService: HelperService,
    private loggerService: LoggerService,
    private http: HttpClient
  ) { }


  getCurrentChapters(): ChapterDetails {
    var primaryChapter = this.memberAppDataService.memberAppData.chapterDetails?.chapters?.find(a => a.isPrimary);


    let cd: ChapterDetails = MapChapterDetails(this.memberAppDataService.memberAppData);

    //reset the previous primary
    if (!!primaryChapter) {
      var prevPrimaryChapter = cd.chapters.find(a => a.code == primaryChapter.code);
      if (prevPrimaryChapter != null) {
        cd.chapters.forEach(a => {
          a.isPrimary = a.code == prevPrimaryChapter.code;
          if (a.isPrimary) {
            a.selected = true;
          }
        });
      }
    }


    return cd;
  }


  giveSomeTestData(): ChapterDetails {
    let chapterDetails: ChapterDetails = {
      chapters: [
        {
          id: "1",
          name: "Florida College of Emergency Physicians",
          code: "FL",
          selected: false,
          isPrimary: false
        },

        {
          id: "2",
          name: "Maryland College of Emergency Physicians",
          code: "MD",
          selected: true,
          isPrimary: true
        },

        {
          id: "4",
          name: "Government Services Chapter",
          code: "US",
          selected: false,
          isPrimary: false
        }
      ]
    };

    return chapterDetails;
  }

  saveChapterMemberships(
    chapterDetails: ChapterDetails
  ): Observable<any> {

    let selectedChapters: ChapterInfo[] = this.commonOpsService.DeepCopyObject(chapterDetails.chapters);
    selectedChapters = selectedChapters.filter(a => a.selected);
    let payload = {
      contactid: this.ssoService.contactid,
      chapters: selectedChapters
    };
    return this.http
      .post(
        this.dataService.memberappapiendpoint.replace('acepmemberappapi', 'accountapi') +
        "UpdateChapterMemberships",
        JSON.stringify(payload)
      )
      .pipe(
        tap(d => {
          //Update addresses dataset in the MemberAppData
        })
      );
  }
}
